/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  MenuItem, TextField, Autocomplete,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { ComponentSelctInput } from './types';

function ComponentSearchableSelectInput({
  control, name, defaultValue, size, entries, errors, required, className,
  disabled, handleChange, showColor = false,
}: ComponentSelctInput) {
  const error = errors?.[name]?.message;

  const showColorsWithSelectInput = (color: string | undefined, text: string) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{
        height: '10px',
        width: '10px',
        borderRadius: '5px',
        backgroundColor: color,
        marginRight: '12px',
      }}
      />
      {text}
    </div>
  );

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <>
          <Autocomplete
            id={name}
            disabled={disabled}
            size={size as 'small' | 'medium' | undefined}
            value={entries.find((e) => e.Value === field.value) || null}
            onChange={(_, newValue) => {
              const val = newValue?.Value ?? '';
              field.onChange(val);
              if (handleChange) handleChange(val as string);
            }}
            options={entries}
            getOptionLabel={(option) => option?.Text?.toString() ?? ''}
            isOptionEqualToValue={(option, value) => option.Value === value.Value}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option.Value}>
                {showColor
                  ? showColorsWithSelectInput(option.ColorCode, option.Text.toString())
                  : option.Text}
              </MenuItem>
            )}
            fullWidth
            className={className}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!error}
                required={required}
                placeholder="Select…"
              />
            )}
          />

          {error && <span className="errorMessage">{String(error)}</span>}
        </>
      )}
    />
  );
}

export default ComponentSearchableSelectInput;
